import { generatePath } from 'react-router-dom';
import { gameConfig } from '../../../shared/gameConfig';
import frontendLog from '../libs/frontendLog';
import { TClassicRoutes } from '../../../../../shared/gameConfig/wowclassic/routes';

export const namedRoutes = gameConfig.Routes as TClassicRoutes;

export function resolveRoutePath(path: string, params?: Object): string {
  try {
    return generatePath(path, params);
  } catch (err) {
    frontendLog.error({ err, path, params }, 'resolveRoutePath failed');
    return '/';
  }
}
